<template>
  <form v-if="purchase" novalidate>
    <h3 class="mb-2">Create review on App '{{ purchase.product.name }}'</h3>
    <hr>
    <div class="alert alert-success" v-if="successfeedback">Thank you for your review!</div>
    <div class="form-group">
      <label for="rate">Rate</label>
      <star-rating id="rate" :class="{'is-invalid': $v.review.comment.$invalid}" v-model="review.rate" :read-only="isDisabled"></star-rating>
      <div v-if="$v.review.rate.$invalid" class="invalid-feedback">Please fill stars</div>
    </div>

    <div class="form-group">
      <label for="comment">Comment:</label>
      <textarea class="form-control" id="comment" :class="{'is-invalid': $v.review.comment.$error}" @input="$v.review.comment.$touch()" v-model="review.comment" rows="3"></textarea>
      <div v-if="$v.review.comment.$error" class="invalid-feedback">Please fill the comment. We appreciate all feedback we receive.</div>
    </div>

    <div class="form-group text-center">
      <button type="submit" class="btn btn-primary mr-2" v-on:click.stop.prevent="save()">Send review</button>
      <router-link role="button" type="cancel" class="btn btn-white" :to="{ name: 'MyPurchases'}">Cancel</router-link>
    </div>
  </form>
</template>

<script>
import StarRating from 'vue-star-rating'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'EditReviewProfile',
  data() {
    return {
      purchase: null,
      review: { rate: null, comment: null, date: new Date() },
      isNew: true,
      successfeedback: false
    }
  },
  components: { 'star-rating': StarRating },
  mixins: [validationMixin],
  validations: {
    review: {
      rate: {
        required
      },
      comment: {
        required
      }
    }
  },
  created: function() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$http
        .get(`purchase/${this.$route.params.id}`, {
          params: { populate: 'product' }
        })
        .then(
          response => {
            this.purchase = response.data
            if (this.purchase.review) {
              this.review = this.purchase.review
              this.isNew = !this.review.comment && !this.review.rate
            }
          },
          err => {
            // error callback
            console.log(err)
          }
        )
    },
    save() {
      if (!this.$v.$invalid) {
        let promise = null
        if (this.isNew) {
          promise = this.$http
            .put(`purchase/${this.$route.params.id}/review`, {
              review: this.review
            })
        } else {
          promise = this.$http
            .post(`purchase/${this.$route.params.id}/review`, {
              review: this.review
            })
        }

        promise.then(
          response => {
            if (this.purchase.review) {
              this.review = this.purchase.review
              this.isNew = false
              this.successfeedback = true
            }
          },
          err => {
            // error callback
            console.log(err)
          }
        )
      } else {
        this.$v.review.comment.$touch()
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/profile/EditReviewProfile.vue